import React from "react";
import { Box, Typography, Button } from "@mui/material";

const EditHeader = ({
  toggleDrawer,
  editItem,
  headerItemData,
  handleApi,
  handleSave,
  isMobile,
}) => {
  let header = "";
  if (isMobile) {
    header = editItem.index === 0 ? "mobileTopbar" : "mobileHeader";
  } else {
    header =
      editItem.index === 0
        ? "customTopbar"
        : editItem.index === 1
          ? "customHeader"
          : "customNavbar";
  }

  const designList = [
    {
      key: "backgroundColor",
      name: "Header - Default Color",
    },
  ];

  return (
    <Box
      sx={{
        borderRadius: "5px",
        width: "100%",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f4f4f4",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#333",
            color: "#fff",
            padding: "5px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              textTransform: "capitalize",
            }}
          >
            Edit {editItem.item}
          </Typography>
        </Box>

        {designList.map((item, index) => {
          return (
            <Box
              key={item.key}
              sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                padding: "0 5px",
                borderBottom: "2px solid #B5B5B5",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  columnGap: "10px",
                }}
              >
                <Typography variant="subtitle1">{item.name}</Typography>

                <Button
                  variant="outlined"
                  onClick={() =>
                    toggleDrawer(
                      editItem.open,
                      editItem.index,
                      "picker",
                      item.key,
                      editItem.item
                    )
                  }
                  sx={{
                    background: isMobile
                      ? headerItemData.customHeader[header].backgroundColor
                      : headerItemData.customHeader[header].backgroundColor,
                    width: "40px",
                    height: "40px",
                    minWidth: "40px",
                    border: "1px solid #ccc",
                  }}
                ></Button>
              </Box>
            </Box>
          );
        })}
      </Box>
      {/* <Box sx={{ width: "90%" }}>
        <TextField
          label="Header Height"
          type="number"
          name="height"
          value={dimensions.height}
          onChange={handleDimensionChange}
          fullWidth
          InputProps={{
            inputProps: {
              max: 150,
              min: 1,
            },
          }}
          sx={{ mt: 2 }}
        />
      </Box> */}
      <Button
        variant="contained"
        color="success"
        fullWidth
        sx={{
          fontSize: "12px",
          padding: "6px",
          width: "90%",
          borderRadius: "50px",
          margin: "15px 0",
        }}
        onClick={handleApi}
      >
        Save
      </Button>
    </Box>
  );
};

export default EditHeader;
